module.exports = __webpack_public_path__ + "8c6cea6305f9bbc81f89839a848131db.png";